var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Link } from "react-router-dom";
import { Button, Dimmer, Loader, Message, Modal, Table } from "semantic-ui-react";
import { AppPaths } from "../AppConfig";
import { getWithAuthn } from "../RequestHelpers";
var AmplifierScaleTracking = /** @class */ (function (_super) {
    __extends(AmplifierScaleTracking, _super);
    function AmplifierScaleTracking(props) {
        var _this = _super.call(this, props) || this;
        _this.renderTable = function (resp) {
            var cols = resp.colLabels.length + 1;
            var width = 100.0 / cols;
            var colStyle = { width: width + "%" };
            return React.createElement(React.Fragment, null,
                React.createElement(Table, { striped: true, celled: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null),
                            resp.colLabels.map(function (label, index) {
                                return React.createElement(Table.HeaderCell, { style: colStyle, key: index }, label);
                            }))),
                    React.createElement(Table.Body, null, resp.rows.map(function (row, rowIndex) {
                        return React.createElement(Table.Row, { key: rowIndex },
                            React.createElement(Table.Cell, null, row.rowLabel),
                            row.values.map(function (value, valueIndex) {
                                return React.createElement(Table.Cell, { key: valueIndex }, _this.renderDetailsCell(resp.colLabels[valueIndex], row.rowLabel, value));
                            }));
                    }))));
        };
        _this.renderDetailsCell = function (colLabel, rowLabel, detailsForAliquot) {
            var minWidth = detailsForAliquot.length > 0 ? '10em' : '0';
            return React.createElement("div", { style: { minWidth: minWidth } },
                detailsForAliquot.map(function (details, index) {
                    var total = details.countPerOrder.reduce(function (accum, current) { return accum + current.count; }, 0);
                    var disabled = total === 0;
                    var modal = React.createElement(Modal, { trigger: React.createElement(Button, { disabled: disabled, icon: 'eye', size: 'tiny' }), closeIcon: true },
                        React.createElement(Modal.Header, null,
                            "Orders with ",
                            colLabel,
                            " - ",
                            rowLabel,
                            " @ ",
                            details.volume,
                            ":"),
                        React.createElement(Modal.Content, null,
                            React.createElement("ul", null, details.countPerOrder
                                .map(function (perOrder, orderIndex) {
                                return React.createElement("li", { key: orderIndex },
                                    "Order ",
                                    React.createElement(Link, { to: AppPaths.ADMIN_ORDER_BASE + "/" + encodeURIComponent(perOrder.orderId) }, perOrder.orderId),
                                    ": x ",
                                    perOrder.count);
                            }))));
                    return React.createElement("p", { key: index },
                        details.volume,
                        ": ",
                        total,
                        "\u00A0",
                        modal);
                }),
                detailsForAliquot.length > 0 ? '' : '-');
        };
        _this.loadData = function () {
            _this.setState({ loading: true }, function () {
                getWithAuthn('/admin/tracking/amplifiers/aliquots')
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            error: false,
                            loading: false,
                            response: resp
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load report: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            error: false
        };
        return _this;
    }
    AmplifierScaleTracking.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { className: 'amplifier-label-report' },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Report could not be loaded."),
            this.state.response && this.renderTable(this.state.response));
    };
    AmplifierScaleTracking.prototype.componentDidMount = function () {
        this.loadData();
    };
    return AmplifierScaleTracking;
}(React.PureComponent));
export default AmplifierScaleTracking;
;
//# sourceMappingURL=AmplifierScaleTracking.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AmplifierScaleTracking.js
// module id = 1451
// module chunks = 0